import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: {
        if: [
          [
            {
              '!=': [
                {
                  '@': 'editingRow',
                },
                null,
              ],
            },
            'Edit Proposal Domain',
          ],
          'Add Proposal Domain',
        ],
      },
      type: 'details',
      content: {
        '{}': {
          fields: {
            '[]': [
              {
                '{}': {
                  id: 'domainId',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!proposal_domain#!entry:!domain',
                        },
                      },
                    },
                  },
                  value: {
                    '@>': [
                      {
                        '@': 'editingRow',
                      },
                      'domainId',
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'code',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!proposal_domain#!entry:!code',
                        },
                      },
                    },
                  },
                  value: {
                    '@>': [
                      {
                        '@': 'editingRow',
                      },
                      'code',
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'name',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!proposal_domain#!entry:!name',
                        },
                      },
                    },
                  },
                  value: {
                    '@>': [
                      {
                        '@': 'editingRow',
                      },
                      'name',
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'id',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!proposal_domain#!entry:!id',
                        },
                      },
                    },
                  },
                  value: {
                    '@>': [
                      {
                        '@': 'editingRow',
                      },
                      'id',
                    ],
                  },
                },
              },
            ],
          },
          onSave: {
            '{}': {
              action: {
                '{}': {
                  alias: 'save.proposal.domain.row',
                },
              },
              variables: {
                '{}': {
                  code: '${field:code}',
                  name: '${field:name}',
                  domainId: '${field:domainId}',
                  proposalId: {
                    '@$': 'proposalId',
                  },
                  proposalDomainId: '${field:id}',
                },
              },
            },
          },
        },
      },
    },
  },
  subqueries: {
    editingRow: {
      filter: {
        '=': [
          {
            '@.': '!id',
          },
          {
            '@$': 'proposalDomainId',
          },
        ],
      },
      target: 'ent:!proposal_domain:!entry',
      quantity: 1,
      selection: {
        '{}': {
          id: {
            '@.': '!id',
          },
          code: {
            '@.': '!code',
          },
          name: {
            '@.': '!name',
          },
          domainId: {
            '@': 'domainRecordId',
          },
        },
      },
      subqueries: {
        domainRecordId: {
          ref: {
            attr: 'attr:ent#!proposal_domain#!entry:!domain',
          },
          target: 'ent:!domains:!domain',
          selection: {
            '@.': '!id',
          },
        },
      },
    },
  },
}
